import { MediaSourceVariant, Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { Locales, notPaidUtmSources, paidUtmSources, Regions } from 'core/user/entities';
import { Location, LocationOption, LocationRegion, LocationRegionOption } from 'core/user/ui';
import { RenderOnlyOnClient } from '../RenderOnlyOnClient';
import { PolicyExtended } from './PolicyExtended';
import { ContainerStyled } from './styled';

type LegalProps = {
  content: {
    basic: string;
    withCheckbox: string;
    withoutCheckbox: string;
    withCheckboxError: string;
  };
  isPolicyAccepted: boolean;
  displayPolicyError: boolean;
  onPolicyClick: (accepted: boolean) => void;
};

export const Legal = ({
  content,
  isPolicyAccepted,
  displayPolicyError,
  onPolicyClick,
}: LegalProps) => {
  return (
    <RenderOnlyOnClient>
      <ContainerStyled alignItems="center">
        <MediaSourceVariant name={paidUtmSources}>
          <LocationRegion>
            <LocationRegionOption option={Regions.CALIFORNIA}>
              <PolicyExtended
                data={content}
                onPolicyClick={onPolicyClick}
                isPolicyAccepted={isPolicyAccepted}
                withoutCheckbox
              />
            </LocationRegionOption>
            <LocationRegionOption option={Regions.OTHER}>
              <Typography
                variant="text-body-xs"
                textAlign="center"
                dangerouslySetInnerHTML={prepareHtml(content.basic)}
              />
            </LocationRegionOption>
          </LocationRegion>
        </MediaSourceVariant>
        <MediaSourceVariant name={notPaidUtmSources}>
          <Location>
            <LocationOption option={Locales.US}>
              <PolicyExtended
                data={content}
                isError={displayPolicyError}
                onPolicyClick={onPolicyClick}
                isPolicyAccepted={isPolicyAccepted}
              />
            </LocationOption>
          </Location>
        </MediaSourceVariant>
      </ContainerStyled>
    </RenderOnlyOnClient>
  );
};
